module.exports = __webpack_public_path__ + "img/success.7277c849.svg";